module.exports = __webpack_public_path__ + "static/media/search-illustration.f533531f.svg";